/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../Fixes';
import Builder from '../../Builder';
import './data';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "sub2": {
        "nested": {
          "assets": {
            "nested": {
              "PlanText": {
                "fields": {
                  "planToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "text": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "PlanTextList": {
                "fields": {
                  "planToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "text": {
                    "type": "string",
                    "id": 2,
                    "rule": "repeated"
                  }
                }
              },
              "PlanFeatureText": {
                "fields": {
                  "planToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "feature": {
                    "type": ".squareup.sub2.data.Feature",
                    "id": 2,
                    "rule": "optional"
                  },
                  "text": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  }
                }
              },
              "FeatureImage": {
                "fields": {
                  "feature": {
                    "type": ".squareup.sub2.data.Feature",
                    "id": 1,
                    "rule": "optional"
                  },
                  "url": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "FeatureText": {
                "fields": {
                  "feature": {
                    "type": ".squareup.sub2.data.Feature",
                    "id": 1,
                    "rule": "optional"
                  },
                  "text": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "TextIcon": {
                "fields": {
                  "text": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "iconName": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "PlanTextAndIconList": {
                "fields": {
                  "planToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "textAndIcon": {
                    "type": ".squareup.sub2.assets.TextIcon",
                    "id": 2,
                    "rule": "repeated"
                  }
                }
              },
              "Viewport": {
                "values": {
                  "DO_NOT_USE_VIEWPORT": 0,
                  "DESKTOP": 1,
                  "MOBILE": 2
                }
              },
              "Image": {
                "fields": {
                  "url": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "recommendedViewport": {
                    "type": ".squareup.sub2.assets.Viewport",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "FullPagePaywall": {
                "fields": {
                  "header": {
                    "type": ".squareup.sub2.assets.PlanFeatureText",
                    "id": 1,
                    "rule": "repeated"
                  },
                  "paragraph": {
                    "type": ".squareup.sub2.assets.PlanFeatureText",
                    "id": 2,
                    "rule": "repeated"
                  },
                  "image": {
                    "type": ".squareup.sub2.assets.FeatureImage",
                    "id": 3,
                    "rule": "repeated"
                  },
                  "tierShortname": {
                    "type": ".squareup.sub2.assets.PlanText",
                    "id": 4,
                    "rule": "repeated"
                  },
                  "tierName": {
                    "type": ".squareup.sub2.assets.PlanText",
                    "id": 5,
                    "rule": "repeated"
                  },
                  "planName": {
                    "type": ".squareup.sub2.assets.PlanText",
                    "id": 6,
                    "rule": "repeated"
                  },
                  "learnMoreUrl": {
                    "type": ".squareup.sub2.assets.FeatureText",
                    "id": 7,
                    "rule": "repeated"
                  }
                }
              },
              "Modal": {
                "fields": {
                  "header": {
                    "type": ".squareup.sub2.assets.PlanText",
                    "id": 1,
                    "rule": "repeated"
                  },
                  "headerTrialOne": {
                    "type": ".squareup.sub2.assets.PlanText",
                    "id": 2,
                    "rule": "repeated"
                  },
                  "headerTrialOther": {
                    "type": ".squareup.sub2.assets.PlanText",
                    "id": 3,
                    "rule": "repeated"
                  },
                  "paragraph": {
                    "type": ".squareup.sub2.assets.PlanFeatureText",
                    "id": 4,
                    "rule": "repeated"
                  },
                  "includes": {
                    "type": ".squareup.sub2.assets.PlanText",
                    "id": 5,
                    "rule": "repeated"
                  },
                  "includedFeatures": {
                    "type": ".squareup.sub2.assets.PlanTextList",
                    "id": 6,
                    "rule": "repeated"
                  },
                  "tierShortname": {
                    "type": ".squareup.sub2.assets.PlanText",
                    "id": 7,
                    "rule": "repeated"
                  },
                  "tierName": {
                    "type": ".squareup.sub2.assets.PlanText",
                    "id": 8,
                    "rule": "repeated"
                  },
                  "planName": {
                    "type": ".squareup.sub2.assets.PlanText",
                    "id": 9,
                    "rule": "repeated"
                  },
                  "learnMoreUrl": {
                    "type": ".squareup.sub2.assets.FeatureText",
                    "id": 10,
                    "rule": "repeated"
                  }
                }
              },
              "PaywallCard": {
                "fields": {
                  "header": {
                    "type": ".squareup.sub2.assets.PlanFeatureText",
                    "id": 1,
                    "rule": "repeated"
                  },
                  "paragraph": {
                    "type": ".squareup.sub2.assets.PlanFeatureText",
                    "id": 2,
                    "rule": "repeated"
                  },
                  "tryOne": {
                    "type": ".squareup.sub2.assets.PlanText",
                    "id": 3,
                    "rule": "repeated"
                  },
                  "tryOther": {
                    "type": ".squareup.sub2.assets.PlanText",
                    "id": 4,
                    "rule": "repeated"
                  },
                  "tierShortname": {
                    "type": ".squareup.sub2.assets.PlanText",
                    "id": 5,
                    "rule": "repeated"
                  },
                  "tierName": {
                    "type": ".squareup.sub2.assets.PlanText",
                    "id": 6,
                    "rule": "repeated"
                  },
                  "planName": {
                    "type": ".squareup.sub2.assets.PlanText",
                    "id": 7,
                    "rule": "repeated"
                  },
                  "learnMoreUrl": {
                    "type": ".squareup.sub2.assets.FeatureText",
                    "id": 8,
                    "rule": "repeated"
                  }
                }
              },
              "Downgrade": {
                "fields": {}
              },
              "TrialWelcome": {
                "fields": {
                  "header": {
                    "type": ".squareup.sub2.assets.PlanText",
                    "id": 1,
                    "rule": "repeated"
                  },
                  "paragraph": {
                    "type": ".squareup.sub2.assets.PlanText",
                    "id": 2,
                    "rule": "repeated"
                  },
                  "image": {
                    "type": ".squareup.sub2.assets.Image",
                    "id": 3,
                    "rule": "repeated"
                  },
                  "tryFeatures": {
                    "type": ".squareup.sub2.assets.PlanText",
                    "id": 4,
                    "rule": "repeated"
                  },
                  "exclusiveFeatures": {
                    "type": ".squareup.sub2.assets.PlanTextList",
                    "id": 5,
                    "rule": "repeated"
                  },
                  "tierName": {
                    "type": ".squareup.sub2.assets.PlanText",
                    "id": 6,
                    "rule": "repeated"
                  }
                }
              },
              "TrialExpiring": {
                "fields": {
                  "header": {
                    "type": ".squareup.sub2.assets.PlanText",
                    "id": 1,
                    "rule": "repeated"
                  },
                  "paragraph": {
                    "type": ".squareup.sub2.assets.PlanText",
                    "id": 2,
                    "rule": "repeated"
                  },
                  "subscribeToKeep": {
                    "type": ".squareup.sub2.assets.PlanText",
                    "id": 3,
                    "rule": "repeated"
                  },
                  "exclusiveFeatures": {
                    "type": ".squareup.sub2.assets.PlanTextList",
                    "id": 4,
                    "rule": "repeated"
                  },
                  "tierName": {
                    "type": ".squareup.sub2.assets.PlanText",
                    "id": 5,
                    "rule": "repeated"
                  }
                }
              },
              "TrialExpired": {
                "fields": {
                  "header": {
                    "type": ".squareup.sub2.assets.PlanText",
                    "id": 1,
                    "rule": "repeated"
                  },
                  "paragraph": {
                    "type": ".squareup.sub2.assets.PlanText",
                    "id": 2,
                    "rule": "repeated"
                  },
                  "subscribeToKeep": {
                    "type": ".squareup.sub2.assets.PlanText",
                    "id": 3,
                    "rule": "repeated"
                  },
                  "exclusiveFeatures": {
                    "type": ".squareup.sub2.assets.PlanTextList",
                    "id": 4,
                    "rule": "repeated"
                  },
                  "tierName": {
                    "type": ".squareup.sub2.assets.PlanText",
                    "id": 5,
                    "rule": "repeated"
                  }
                }
              },
              "MigrationOptIn": {
                "fields": {
                  "header": {
                    "type": ".squareup.sub2.assets.PlanText",
                    "id": 1,
                    "rule": "repeated"
                  },
                  "paragraph": {
                    "type": ".squareup.sub2.assets.PlanText",
                    "id": 2,
                    "rule": "repeated"
                  },
                  "image": {
                    "type": ".squareup.sub2.assets.Image",
                    "id": 3,
                    "rule": "repeated"
                  },
                  "cardRequiredDisclaimer": {
                    "type": ".squareup.sub2.assets.PlanText",
                    "id": 4,
                    "rule": "repeated"
                  },
                  "includedFeatures": {
                    "type": ".squareup.sub2.assets.PlanTextList",
                    "id": 5,
                    "rule": "repeated"
                  },
                  "tierName": {
                    "type": ".squareup.sub2.assets.PlanText",
                    "id": 6,
                    "rule": "repeated"
                  },
                  "viewAllFeaturesUrl": {
                    "type": ".squareup.sub2.assets.PlanText",
                    "id": 7,
                    "rule": "repeated"
                  },
                  "includedFeaturesHeader": {
                    "type": ".squareup.sub2.assets.PlanText",
                    "id": 8,
                    "rule": "repeated"
                  }
                }
              },
              "PlanPromotionalPricingText": {
                "fields": {
                  "planToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "defaultPricing": {
                    "type": ".squareup.sub2.data.LocalizedHeadlinePlanPricing",
                    "id": 2,
                    "rule": "optional"
                  },
                  "promotionalPricing": {
                    "type": ".squareup.sub2.data.LocalizedHeadlinePlanPricing",
                    "id": 3,
                    "rule": "optional"
                  },
                  "discountRate": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "promotionalPricingDisclaimer": {
                    "type": "string",
                    "id": 5,
                    "rule": "optional"
                  }
                }
              },
              "MigrationOptOut": {
                "fields": {
                  "header": {
                    "type": ".squareup.sub2.assets.PlanText",
                    "id": 1,
                    "rule": "repeated"
                  },
                  "paragraph": {
                    "type": ".squareup.sub2.assets.PlanText",
                    "id": 2,
                    "rule": "repeated"
                  },
                  "paragraph2": {
                    "type": ".squareup.sub2.assets.PlanText",
                    "id": 3,
                    "rule": "repeated"
                  },
                  "includedFeatures": {
                    "type": ".squareup.sub2.assets.PlanTextAndIconList",
                    "id": 4,
                    "rule": "repeated"
                  },
                  "exploreAllFeaturesUrl": {
                    "type": ".squareup.sub2.assets.PlanText",
                    "id": 5,
                    "rule": "repeated"
                  },
                  "footer": {
                    "type": ".squareup.sub2.assets.PlanText",
                    "id": 6,
                    "rule": "repeated"
                  },
                  "processingFeesUrl": {
                    "type": ".squareup.sub2.assets.PlanText",
                    "id": 7,
                    "rule": "repeated"
                  },
                  "planPromotionalPricingText": {
                    "type": ".squareup.sub2.assets.PlanPromotionalPricingText",
                    "id": 8,
                    "rule": "repeated"
                  }
                }
              },
              "DefaultProcessingFees": {
                "fields": {
                  "cardPresentRateName": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "cardNotPresentRateName": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "onlineRateName": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "onlineApiRateName": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "achApiRateName": {
                    "type": "string",
                    "id": 5,
                    "rule": "optional"
                  },
                  "achInvoicesRateName": {
                    "type": "string",
                    "id": 6,
                    "rule": "optional"
                  },
                  "afterpayRateName": {
                    "type": "string",
                    "id": 7,
                    "rule": "optional"
                  },
                  "giftCardLoadRateName": {
                    "type": "string",
                    "id": 8,
                    "rule": "optional"
                  },
                  "appSubscriptionsRateName": {
                    "type": "string",
                    "id": 9,
                    "rule": "optional"
                  },
                  "achAppSubscriptionsRateName": {
                    "type": "string",
                    "id": 10,
                    "rule": "optional"
                  },
                  "appSubscriptionsMarketplaceRateName": {
                    "type": "string",
                    "id": 11,
                    "rule": "optional"
                  },
                  "cashBusinessRateName": {
                    "type": "string",
                    "id": 12,
                    "rule": "optional"
                  },
                  "internalAccountsRateName": {
                    "type": "string",
                    "id": 13,
                    "rule": "optional"
                  },
                  "costPlusMarginRateName": {
                    "type": "string",
                    "id": 14,
                    "rule": "optional"
                  },
                  "interchangePlusMarginRateName": {
                    "type": "string",
                    "id": 15,
                    "rule": "optional"
                  },
                  "freeRateName": {
                    "type": "string",
                    "id": 16,
                    "rule": "optional"
                  },
                  "cardPresentRateDisplay": {
                    "type": ".squareup.sub2.assets.PlanText",
                    "id": 17,
                    "rule": "repeated"
                  },
                  "cardNotPresentRateDisplay": {
                    "type": ".squareup.sub2.assets.PlanText",
                    "id": 18,
                    "rule": "repeated"
                  },
                  "onlineRateDisplay": {
                    "type": ".squareup.sub2.assets.PlanText",
                    "id": 19,
                    "rule": "repeated"
                  },
                  "onlineApiRateDisplay": {
                    "type": ".squareup.sub2.assets.PlanText",
                    "id": 20,
                    "rule": "repeated"
                  },
                  "achApiRateDisplay": {
                    "type": ".squareup.sub2.assets.PlanText",
                    "id": 21,
                    "rule": "repeated"
                  },
                  "achInvoicesRateDisplay": {
                    "type": ".squareup.sub2.assets.PlanText",
                    "id": 22,
                    "rule": "repeated"
                  },
                  "afterpayRateDisplay": {
                    "type": ".squareup.sub2.assets.PlanText",
                    "id": 23,
                    "rule": "repeated"
                  },
                  "giftCardLoadRateDisplay": {
                    "type": ".squareup.sub2.assets.PlanText",
                    "id": 24,
                    "rule": "repeated"
                  },
                  "appSubscriptionsRateDisplay": {
                    "type": ".squareup.sub2.assets.PlanText",
                    "id": 25,
                    "rule": "repeated"
                  },
                  "achAppSubscriptionsRateDisplay": {
                    "type": ".squareup.sub2.assets.PlanText",
                    "id": 26,
                    "rule": "repeated"
                  },
                  "appSubscriptionsMarketplaceRateDisplay": {
                    "type": ".squareup.sub2.assets.PlanText",
                    "id": 27,
                    "rule": "repeated"
                  },
                  "cashBusinessRateDisplay": {
                    "type": ".squareup.sub2.assets.PlanText",
                    "id": 28,
                    "rule": "repeated"
                  },
                  "internalAccountsRateDisplay": {
                    "type": ".squareup.sub2.assets.PlanText",
                    "id": 29,
                    "rule": "repeated"
                  },
                  "costPlusMarginRateDisplay": {
                    "type": ".squareup.sub2.assets.PlanText",
                    "id": 30,
                    "rule": "repeated"
                  },
                  "interchangePlusMarginRateDisplay": {
                    "type": ".squareup.sub2.assets.PlanText",
                    "id": 31,
                    "rule": "repeated"
                  },
                  "freeRateDisplay": {
                    "type": ".squareup.sub2.assets.PlanText",
                    "id": 32,
                    "rule": "repeated"
                  }
                }
              },
              "FeatureLoss": {
                "fields": {
                  "features": {
                    "type": ".squareup.sub2.assets.FeatureText",
                    "id": 1,
                    "rule": "repeated"
                  }
                }
              },
              "PricingCategory": {
                "fields": {
                  "category": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "subcategories": {
                    "type": ".squareup.sub2.assets.PricingSubCategory",
                    "id": 2,
                    "rule": "repeated"
                  }
                }
              },
              "PricingSubCategory": {
                "fields": {
                  "subcategory": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "features": {
                    "type": ".squareup.sub2.assets.PricingFeature",
                    "id": 2,
                    "rule": "repeated"
                  }
                }
              },
              "PricingFeature": {
                "fields": {
                  "feature": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "tooltip": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "includedFree": {
                    "type": "bool",
                    "id": 3,
                    "rule": "optional"
                  },
                  "includedPlus": {
                    "type": "bool",
                    "id": 4,
                    "rule": "optional"
                  },
                  "includedPremium": {
                    "type": "bool",
                    "id": 5,
                    "rule": "optional"
                  },
                  "freeText": {
                    "type": "string",
                    "id": 6,
                    "rule": "optional"
                  },
                  "plusText": {
                    "type": "string",
                    "id": 7,
                    "rule": "optional"
                  },
                  "premiumText": {
                    "type": "string",
                    "id": 8,
                    "rule": "optional"
                  }
                }
              },
              "FeatureGrid": {
                "fields": {
                  "categories": {
                    "type": ".squareup.sub2.assets.PricingCategory",
                    "id": 1,
                    "rule": "repeated"
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.sub2?.nested?.assets?.nested?.PlanText && !$root.nested?.squareup?.nested?.sub2?.nested?.assets?.nested?.PlanTextList && !$root.nested?.squareup?.nested?.sub2?.nested?.assets?.nested?.PlanFeatureText && !$root.nested?.squareup?.nested?.sub2?.nested?.assets?.nested?.FeatureImage && !$root.nested?.squareup?.nested?.sub2?.nested?.assets?.nested?.FeatureText && !$root.nested?.squareup?.nested?.sub2?.nested?.assets?.nested?.TextIcon && !$root.nested?.squareup?.nested?.sub2?.nested?.assets?.nested?.PlanTextAndIconList && !$root.nested?.squareup?.nested?.sub2?.nested?.assets?.nested?.Viewport && !$root.nested?.squareup?.nested?.sub2?.nested?.assets?.nested?.Image && !$root.nested?.squareup?.nested?.sub2?.nested?.assets?.nested?.FullPagePaywall && !$root.nested?.squareup?.nested?.sub2?.nested?.assets?.nested?.Modal && !$root.nested?.squareup?.nested?.sub2?.nested?.assets?.nested?.PaywallCard && !$root.nested?.squareup?.nested?.sub2?.nested?.assets?.nested?.Downgrade && !$root.nested?.squareup?.nested?.sub2?.nested?.assets?.nested?.TrialWelcome && !$root.nested?.squareup?.nested?.sub2?.nested?.assets?.nested?.TrialExpiring && !$root.nested?.squareup?.nested?.sub2?.nested?.assets?.nested?.TrialExpired && !$root.nested?.squareup?.nested?.sub2?.nested?.assets?.nested?.MigrationOptIn && !$root.nested?.squareup?.nested?.sub2?.nested?.assets?.nested?.PlanPromotionalPricingText && !$root.nested?.squareup?.nested?.sub2?.nested?.assets?.nested?.MigrationOptOut && !$root.nested?.squareup?.nested?.sub2?.nested?.assets?.nested?.DefaultProcessingFees && !$root.nested?.squareup?.nested?.sub2?.nested?.assets?.nested?.FeatureLoss && !$root.nested?.squareup?.nested?.sub2?.nested?.assets?.nested?.PricingCategory && !$root.nested?.squareup?.nested?.sub2?.nested?.assets?.nested?.PricingSubCategory && !$root.nested?.squareup?.nested?.sub2?.nested?.assets?.nested?.PricingFeature && !$root.nested?.squareup?.nested?.sub2?.nested?.assets?.nested?.FeatureGrid) {
  $root.addJSON(jsonData);
}

/**
 * Text specific to a particular plan.
 *
 * SOURCE PlanText @ squareup/sub2/assets.proto at 11:1
 */
export const PlanText = $root.lookupType('squareup.sub2.assets.PlanText');
fixType(PlanText);
Builder.createAndAttachToType(PlanText);
/**
 * Multi-line text specific to a particular plan.
 *
 * SOURCE PlanTextList @ squareup/sub2/assets.proto at 19:1
 */
export const PlanTextList = $root.lookupType('squareup.sub2.assets.PlanTextList');
fixType(PlanTextList);
Builder.createAndAttachToType(PlanTextList);
/**
 * Text specific to a particular (plan, feature) tuple.
 *
 * SOURCE PlanFeatureText @ squareup/sub2/assets.proto at 27:1
 */
export const PlanFeatureText = $root.lookupType('squareup.sub2.assets.PlanFeatureText');
fixType(PlanFeatureText);
Builder.createAndAttachToType(PlanFeatureText);
/**
 * Image specific to a particular feature.
 *
 * SOURCE FeatureImage @ squareup/sub2/assets.proto at 36:1
 */
export const FeatureImage = $root.lookupType('squareup.sub2.assets.FeatureImage');
fixType(FeatureImage);
Builder.createAndAttachToType(FeatureImage);
/**
 * Text specific to a particular feature.
 *
 * SOURCE FeatureText @ squareup/sub2/assets.proto at 44:1
 */
export const FeatureText = $root.lookupType('squareup.sub2.assets.FeatureText');
fixType(FeatureText);
Builder.createAndAttachToType(FeatureText);
/**
 * A paired text and Market icon. Useful for things like lists
 * of features with unique icons for bullets.
 *
 * SOURCE TextIcon @ squareup/sub2/assets.proto at 53:1
 */
export const TextIcon = $root.lookupType('squareup.sub2.assets.TextIcon');
fixType(TextIcon);
Builder.createAndAttachToType(TextIcon);
/**
 * A list of paired icons and text specific to a particular plan.
 *
 * SOURCE PlanTextAndIconList @ squareup/sub2/assets.proto at 62:1
 */
export const PlanTextAndIconList = $root.lookupType('squareup.sub2.assets.PlanTextAndIconList');
fixType(PlanTextAndIconList);
Builder.createAndAttachToType(PlanTextAndIconList);
/**
 * SOURCE Viewport @ squareup/sub2/assets.proto at 67:1
 */
export const Viewport = $root.lookupEnum('squareup.sub2.assets.Viewport').values;
/**
 * Standard Image.
 *
 * SOURCE Image @ squareup/sub2/assets.proto at 76:1
 */
export const Image = $root.lookupType('squareup.sub2.assets.Image');
fixType(Image);
Builder.createAndAttachToType(Image);
/**
 * See: https://www.figma.com/design/A7VccamBERizA8pkMjB7Q0/Unified-Upsell-Patterns
 *
 * SOURCE FullPagePaywall @ squareup/sub2/assets.proto at 84:1
 */
export const FullPagePaywall = $root.lookupType('squareup.sub2.assets.FullPagePaywall');
fixType(FullPagePaywall);
Builder.createAndAttachToType(FullPagePaywall);
/**
 * See: https://www.figma.com/design/A7VccamBERizA8pkMjB7Q0/Unified-Upsell-Patterns
 *
 * SOURCE Modal @ squareup/sub2/assets.proto at 97:1
 */
export const Modal = $root.lookupType('squareup.sub2.assets.Modal');
fixType(Modal);
Builder.createAndAttachToType(Modal);
/**
 * See: https://www.figma.com/design/A7VccamBERizA8pkMjB7Q0/Unified-Upsell-Patterns
 *
 * SOURCE PaywallCard @ squareup/sub2/assets.proto at 113:1
 */
export const PaywallCard = $root.lookupType('squareup.sub2.assets.PaywallCard');
fixType(PaywallCard);
Builder.createAndAttachToType(PaywallCard);
/**
 * SOURCE Downgrade @ squareup/sub2/assets.proto at 124:1
 */
export const Downgrade = $root.lookupType('squareup.sub2.assets.Downgrade');
fixType(Downgrade);
Builder.createAndAttachToType(Downgrade);
/**
 * SOURCE TrialWelcome @ squareup/sub2/assets.proto at 126:1
 */
export const TrialWelcome = $root.lookupType('squareup.sub2.assets.TrialWelcome');
fixType(TrialWelcome);
Builder.createAndAttachToType(TrialWelcome);
/**
 * SOURCE TrialExpiring @ squareup/sub2/assets.proto at 135:1
 */
export const TrialExpiring = $root.lookupType('squareup.sub2.assets.TrialExpiring');
fixType(TrialExpiring);
Builder.createAndAttachToType(TrialExpiring);
/**
 * SOURCE TrialExpired @ squareup/sub2/assets.proto at 143:1
 */
export const TrialExpired = $root.lookupType('squareup.sub2.assets.TrialExpired');
fixType(TrialExpired);
Builder.createAndAttachToType(TrialExpired);
/**
 * SOURCE MigrationOptIn @ squareup/sub2/assets.proto at 151:1
 */
export const MigrationOptIn = $root.lookupType('squareup.sub2.assets.MigrationOptIn');
fixType(MigrationOptIn);
Builder.createAndAttachToType(MigrationOptIn);
/**
 * Represents the localized promotional pricing information.
 *
 * SOURCE PlanPromotionalPricingText @ squareup/sub2/assets.proto at 163:1
 */
export const PlanPromotionalPricingText = $root.lookupType('squareup.sub2.assets.PlanPromotionalPricingText');
fixType(PlanPromotionalPricingText);
Builder.createAndAttachToType(PlanPromotionalPricingText);
/**
 * SOURCE MigrationOptOut @ squareup/sub2/assets.proto at 177:1
 */
export const MigrationOptOut = $root.lookupType('squareup.sub2.assets.MigrationOptOut');
fixType(MigrationOptOut);
Builder.createAndAttachToType(MigrationOptOut);
/**
 * Assets related to default (i.e. not seller-specific) processing fees
 *
 * SOURCE DefaultProcessingFees @ squareup/sub2/assets.proto at 191:1
 */
export const DefaultProcessingFees = $root.lookupType('squareup.sub2.assets.DefaultProcessingFees');
fixType(DefaultProcessingFees);
Builder.createAndAttachToType(DefaultProcessingFees);
/**
 * SOURCE FeatureLoss @ squareup/sub2/assets.proto at 258:1
 */
export const FeatureLoss = $root.lookupType('squareup.sub2.assets.FeatureLoss');
fixType(FeatureLoss);
Builder.createAndAttachToType(FeatureLoss);
/**
 * A category of features. Ex: Payments & Checkout
 *
 * SOURCE PricingCategory @ squareup/sub2/assets.proto at 277:1
 */
export const PricingCategory = $root.lookupType('squareup.sub2.assets.PricingCategory');
fixType(PricingCategory);
Builder.createAndAttachToType(PricingCategory);
/**
 * A subcategory of features. Ex: Payment Methods
 *
 * SOURCE PricingSubCategory @ squareup/sub2/assets.proto at 283:1
 */
export const PricingSubCategory = $root.lookupType('squareup.sub2.assets.PricingSubCategory');
fixType(PricingSubCategory);
Builder.createAndAttachToType(PricingSubCategory);
/**
 * Represents the availability and pricing information of a feature across Square One plans
 *
 * SOURCE PricingFeature @ squareup/sub2/assets.proto at 289:1
 */
export const PricingFeature = $root.lookupType('squareup.sub2.assets.PricingFeature');
fixType(PricingFeature);
Builder.createAndAttachToType(PricingFeature);
/**
 * Represents the feature comparison grid for Square One plans
 *
 * SOURCE FeatureGrid @ squareup/sub2/assets.proto at 301:1
 */
export const FeatureGrid = $root.lookupType('squareup.sub2.assets.FeatureGrid');
fixType(FeatureGrid);
Builder.createAndAttachToType(FeatureGrid);